import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import API from "../../axios";
import { useNavigate, useParams } from "react-router-dom";

const RFQTable = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>([]);

    const loadData = async function () {
        setLoading(true);
        try {
            const result: any = await API.getRFQList();

            setData(result.data);
        } catch (error) {}
        setLoading(false);
    };

    function isDateOlderThanToday(dateString: string): boolean {
        const inputDate = new Date(dateString);
        const today = new Date();

        inputDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return inputDate < today;
    }

    function isDateInTwoDays(dateString: string): boolean {
        const inputDate = new Date(dateString);
        const today = new Date();
        const twoDaysFromNow = new Date();

        inputDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        twoDaysFromNow.setHours(0, 0, 0, 0);
        twoDaysFromNow.setDate(today.getDate() + 2);

        return inputDate.getTime() === twoDaysFromNow.getTime();
    }

    function getNextStepColor(date: string | undefined) {
        if (!date) {
            return "#fff";
        }

        if (isDateOlderThanToday(date)) {
            return "#fa7f52ff";
        } else if (isDateInTwoDays(date)) {
            return "#e0f052ff";
        } else {
            return "#43bd38ff";
        }
    }

    function truncateText(text: string | null, maxLength: number = 20): string {
        if (!text) return "";
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + "...";
    }

    function handleGoToNextStepAction(id: number) {
        window.open(
            `https://odoo-ps-psae-carandx.odoo.com/web#id=${id}&cids=3&menu_id=309&action=470&model=purchase.order&view_type=form`,
            "_blank",
            "noopener,noreferrer"
        );
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="min-vh-100" style={{ overflow: "hidden" }}>
            <div className="container-fluid" style={{ marginTop: 100 }}>
                {/* Header */}
                <Row>
                    <Col cols="6" className="d-flex align-items-center gap-2">
                        <a
                            className="btn btn-outline-black btn-md mx-1"
                            onClick={() => navigate(-1)}
                        >
                            <i className="bi bi-chevron-left fs-4"></i>
                        </a>
                        <h3 className="fw-medium text-primary">
                            To Be Shipped
                        </h3>
                    </Col>
                </Row>
                <div
                    className="card"
                    style={{
                        marginTop: "1rem",
                        marginBottom: 100,
                        borderWidth: 1,
                        borderColor: "#d8d8d8ff",
                    }}
                >
                    {loading ? (
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ minHeight: "70vh" }}
                        >
                            <div className="text-center">
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{
                                        width: "3rem",
                                        height: "3rem",
                                    }}
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </div>
                                <p className="mt-3 text-muted">
                                    Loading shipping data...
                                </p>
                            </div>
                        </div>
                    ) : (
                        <table
                            className="table table-hover mb-0"
                            style={{
                                borderRight: "1px solid #efefef",
                                position: "sticky",
                                left: 0,
                            }}
                        >
                            {/* Table Header */}
                            <thead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "#0d6efd",
                                    color: "white",
                                    zIndex: 10,
                                }}
                            >
                                <tr>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        Po Number
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        Vendor Ref
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        Bl Number
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        Product
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        Dropship
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        QTY
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        Waiting QTY
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        Shipped QTY
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        Partner
                                    </th>
                                    <th
                                        className="fw-semibold text-uppercase"
                                        style={{
                                            fontSize: "0.7rem",
                                            color: "#6c757d",
                                            padding: "0.6rem",
                                            borderBottom: "2px solid #dee2e6",
                                            whiteSpace: "nowrap",
                                            minWidth: 120,
                                        }}
                                    >
                                        NextStep
                                    </th>
                                </tr>
                            </thead>
                            {/* Table Body */}
                            <tbody>
                                {data.map((row: any, idx: number) => (
                                    <tr
                                        key={idx}
                                        style={{
                                            borderBottom: "1px solid #f0f0f0",
                                            height: 50,
                                            fontSize: 10,
                                        }}
                                    >
                                        {/* PO number */}
                                        <td
                                            style={{
                                                fontWeight: "500",
                                                color: "#495057",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    overflow: "visible",
                                                }}
                                            >
                                                {truncateText(row.po_number)}
                                            </div>
                                        </td>

                                        {/* Vendor Ref */}
                                        <td
                                            style={{
                                                fontWeight: "500",
                                                color: "#495057",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {truncateText(
                                                    row.vendor_reference
                                                )}
                                            </div>
                                        </td>

                                        {/* BL Number */}
                                        <td
                                            style={{
                                                fontWeight: "500",
                                                color: "#495057",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    overflow: "visible",
                                                }}
                                            >
                                                {row.bl_number || "-"}
                                            </div>
                                        </td>

                                        {/* 
                        Product Name Column
                        Show as list view when the product list greater than 1 
                        */}
                                        <td
                                            style={{
                                                fontWeight: "500",
                                                color: "#495057",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    overflow: "visible",
                                                }}
                                            >
                                                {row.products.length > 1 ? (
                                                    <select
                                                        style={{
                                                            padding: "2px 6px",
                                                            border: "1px solid #dee2e6",
                                                            borderRadius: "4px",
                                                            backgroundColor:
                                                                "white",
                                                            cursor: "pointer",
                                                            fontSize: "0.75rem",
                                                            width: "100%",
                                                            maxWidth: "200px",
                                                        }}
                                                    >
                                                        <option disabled>
                                                            Products (
                                                            {
                                                                row.products
                                                                    .length
                                                            }
                                                            )
                                                        </option>
                                                        {row.products.map(
                                                            (
                                                                product: any,
                                                                index: number
                                                            ) => (
                                                                <option
                                                                    key={index}
                                                                >
                                                                    {truncateText(
                                                                        typeof product ===
                                                                            "string"
                                                                            ? product
                                                                            : product.name ||
                                                                                  product,
                                                                        30
                                                                    )}
                                                                    (
                                                                    {
                                                                        product.qty
                                                                    }
                                                                    )
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                ) : (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection:
                                                                "row",
                                                            whiteSpace:
                                                                "nowrap",
                                                            overflow: "hidden",
                                                            maxWidth: 100,
                                                        }}
                                                    >
                                                        {row.products[0]?.name}
                                                    </div>
                                                )}
                                            </div>
                                        </td>

                                        {/* Dropship Column */}
                                        <td
                                            style={{
                                                color: "#495057",
                                                fontSize: 12,
                                            }}
                                        >
                                            <span
                                                className="badge badge-primary "
                                                style={{
                                                    backgroundColor:
                                                        row.is_dropship
                                                            ? "#039d0bff"
                                                            : "#818181ff",
                                                    margin: 0,
                                                }}
                                            >
                                                {row.is_dropship ? "yes" : "no"}
                                            </span>
                                        </td>

                                        {/* QTY Column */}
                                        <td
                                            style={{
                                                color: "#495057",
                                            }}
                                        >
                                            {row.qty || "-"}
                                        </td>

                                        {/* Waiting QTY Column */}
                                        <td
                                            style={{
                                                color: "#495057",
                                            }}
                                        >
                                            {row.waiting_qty || "-"}
                                        </td>

                                        {/* Shipped QTY Column */}
                                        <td
                                            style={{
                                                color: "#495057",
                                            }}
                                        >
                                            {row.shipped_qty || "-"}
                                        </td>
                                        {/* Partner */}
                                        <td
                                            style={{
                                                color: "#495057",
                                            }}
                                        >
                                            {(row.is_dropship &&
                                                truncateText(row.partner)) ||
                                                "-"}
                                        </td>

                                        {/** Next step */}
                                        <td
                                            style={{
                                                color: "#202020ff",
                                                fontWeight: "700",
                                                backgroundColor:
                                                    getNextStepColor(
                                                        row.next_step
                                                            ?.date_deadline
                                                    ),
                                                textDecoration: "underline",
                                            }}
                                            onClick={() =>
                                                handleGoToNextStepAction(row.id)
                                            }
                                        >
                                            {row.next_step?.name}
                                            <i className="bi bi-arrow-right fs-8 mx-1"></i>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RFQTable;
